import { useMemo, useState, useEffect } from "react";
import { customAPI } from "../services/api";
import { useQuery, useMutation } from "react-query";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
const size = 20;

const getMangeSecurityGroups = (token, page, sort, InternalName,isFetchAll) =>
  customAPI(token)
    .get("api/Groups/GetSecurityGroups", {
      params: {
        size:isFetchAll?100000:size,
        page,
        InternalName: InternalName,
        orderBy:
          sort?.length && sort?.filter((i) => i.value)?.length
            ? `${sort.filter((i) => i.value).map((k) => `Fields/${k.subKey}`)}`
            : undefined,
        sort:
          sort?.length && sort?.filter((i) => i.value)?.length
            ? `${sort.filter((i) => i.value).map((k) => `${k.value}`)}`
            : undefined,
      },
    })
    .then((res) => res?.data?.data);

const normalizer = (items) => {
  const newItems = items?.map((item) => ({
    id: item?.id,
    createdUser: item?.createdBy,
    modifiedUser: item?.modifiedBy,
    displayName: item?.displayName,
    internalName: item?.internalName,
  }));

  return newItems;
};
const deleteSecurityGroup = (data, token) => {
  return customAPI(token).delete("/api/Groups/" + data.id+"/DeleteSecurityGroup");
};

export const useManageSecurityGroupsAPI = ({ page = 1, sort,  InternalName ,isFetchAll}) => {
  const { token } = useSelector((store) => store.auth);
  const [queryVariables, setQueryVariables] = useState({

    InternalName: InternalName,
  });
  useEffect(() => {
    setQueryVariables({
      ...{
        InternalName: InternalName
      },
    });
  }, [InternalName]);
  const deleteMutation = useMutation((data) => deleteSecurityGroup(data, token), {
    onError: (error) => {
      if (error.response.status == 409) {
        toast.error(error.response.data.message);
        return error;
      } else {
        error.message = "Something went wrong";
        return error;
      }
    },
  });
  const handledeleteSecurityGroups = async (list, onSuccess) => {
    try {
      list.forEach((user) => {
        deleteMutation.mutate(user, {
          onSuccess: () => {
            refetch();
            onSuccess();
          },
        });
      });
    } catch (err) {
      console.log(err);
    }
  };
  const { data, isLoading, refetch } = useQuery(
    [`GET-securitygroups-${page}-${sort?.map((i) => `${i.key}-${i.value}`)}`, queryVariables],
    () => getMangeSecurityGroups(token, page, sort, InternalName,isFetchAll)
  );
  const normlizedData = useMemo(() => normalizer(data), [data]);

  return {
    data: normlizedData,
    isLoadingList: isLoading,
    refetchList: refetch,
    handledeleteSecurityGroups,
  };
};
